<template>
    <ListeFiliereNiveauMatiere/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeFiliereNiveauMatiere from "@/components/FiliereNiveauMatiere/ListeFiliereNiveauMatiere..vue";

    export default defineComponent({
      name: "ListeFiliereNiveauMatierePage",
      components: {
        
        ListeFiliereNiveauMatiere,
      },
    });
  </script>